// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1G9gENUeEpR-9_rnvHbwrj {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n", "",{"version":3,"sources":["webpack://src/common/components/page/_styles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "_1G9gENUeEpR-9_rnvHbwrj"
};
export default ___CSS_LOADER_EXPORT___;
